// extracted by mini-css-extract-plugin
export default {"body":"announcement_body__2WAc4","image":"announcement_image__K4n0L","link":"announcement_link__cXPpg","skeleton":"announcement_skeleton__TYPWB"};